<template>
  <div class="container">
  <Header color="black" type="form"
    :spanishDisabled="true"
     ></Header>

    <div class="top px-0 pb-0" aria-label="Back">
      <h1 class="px-5 mb-4">
        <button
          type="button"
          class="btn p-0"
          title="Back"
          innerText="Back"
          aria-label="Back"
          @click="back()"
          @keyup.enter="back()"
        >
          <Tcon icon="f-chevron-left" class="chevron-left" tabindex="0" />
        </button>
        FCC Broadband Label
      </h1>
    </div>
    <BroadbandLabelForm v-if="step == 1"
      :currStep="step"
      :selections="fcc_form_selections"
      @advance="handleNext"
      @taxgeocode="setTaxgeocode"
      @fcc_label_id="setFccLabelId"
      @comm_eff_dt="setCommEffDate"
      @acct_type="setAcctType"
      @sub_type="setSubType"
      @fcc_form_selections="setFccFormSelections"
    />
    <BroadbandLabel v-if="step == 2" 
      :taxgeocode="taxgeocode"
      :fcc_label_id="fcc_label_id"
      :comm_eff_dt="comm_eff_dt"
      :acct_type="acct_type"
      :sub_type="sub_type"
      :fcc_form_selections="fcc_form_selections"
    />
  
    
  </div>
</template>
  <script>
  import Tcon from "../iconography/Tcon";

  import Header from "../components/Header.vue";
  import BroadbandLabelForm from "../components/BroadbandLabelForm.vue";
  import BroadbandLabel from "../components/BroadbandLabel.vue";
  
  export default {
    name: "BroadbandFacts",
    components: {
        Header,
        BroadbandLabelForm,
        Tcon,
        BroadbandLabel,
    },
    data() {
      return {
        step: 1,
        fcc_label_id: "",
        taxgeocode: "",
        comm_eff_dt: "",
        acct_type: "",
        sub_type: "",
        fcc_form_selections: {},
      };
    },
    watch: {

    },
    methods: {
      back() {
        this.step = this.step - 1;    
        
        if (this.step < 1) this.$router.push('/promotions');
      },
      handleNext(event) {
        this.step = event;
      },
      setFccLabelId(event) {
        this.fcc_label_id = event;
      },
      setTaxgeocode(event) {
        this.taxgeocode = event;
      },
      setCommEffDate(event) {
        this.comm_eff_dt = event;
      },
      setFccFormSelections(event) {
        this.fcc_form_selections = event;
      },
      setAcctType(event) {
        this.acct_type = event;
      },
      setSubType(event) {
        this.sub_type = event;
      },

    }

  };
  </script>
  
  <style scoped>
  svg {
    height: 25vh;
    width: 100vw;
    margin-top: -11rem;
    z-index: -1;
    position:fixed;
    bottom: 0px;
  }
  
  .container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  
 
  
  .container > div,
  .container > header {
    flex: none;
    padding: 2.5vh 5vw;
  }
  
  .container > header.ext {
    padding: 2.5vh 1vw;
  }
  
  p {
    margin-bottom: 0px;
  }
  
  /* smaller than iPad screens and landscape */
  @media (max-width: 960px) and (max-height: 600px) {
    svg {
      margin-top: 0;
    }
  }

  .bottom {
  background: #dcdfe3; /* Grey 300 */
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 47%;
  position:relative;
}
.chevron-left {
  height: 2rem;
  width: 2rem;
}
  </style>
  